<template>
  <div class="z-main dark-color" style="height: 100%;" ref="container">
    <header class="z-header d-space-row" style="border-bottom:1px solid #515151;background: #fff;">
      <div>
        <router-link to="/my/withdraw">
          <img class="hearIcon" src="../../assets/sysbars/left.png">
        </router-link>
      </div>
      <div class="dark-color">账单</div>
      <div></div>
    </header>
    <div class="z-body" style="bottom: 0;">
      <div class=" d-center-row pad-all" style="width: 100%;">
        <div class="bill-tabbar d-space-row">
          <div :class="['common-tab',currentTab==1?'active':'']" @click="onChangeCurrent(1)">收入</div>
          <div :class="['common-tab',currentTab==2?'active':'']" @click="onChangeCurrent(2)">支出</div>
        </div>
      </div>
      <v-tabs color="#fff;" @change="onChange" ref="inner">
        <v-tabs-slider color="#000"></v-tabs-slider>
        <div style="width: 100%; display: flex;justify-content: space-between;align-items: center; background: #F8F8F8;">
          <div>
            <v-tab style="color: #000;">佣金收入</v-tab>
          </div>
          <div>
            <v-tab style="color: #000;">盈利分成</v-tab>
          </div>
          <div>
            <v-tab style="color: #000;">感恩奖励</v-tab>
          </div>
          <div>
            <v-tab style="color: #000;">推荐奖励</v-tab>
          </div>
          <div>
            <v-tab style="color: #000;">通证明细</v-tab>
          </div>
        </div>
      </v-tabs>
      <div class=" d-space-column" ref="bill" id="z-bill-mescroll">
        <div class="d-space-column" style="width: 100%;">
          <div v-for="(billItem,billIndex) in bill" :key="billIndex" class="d-space-row" style="width: 100%;box-sizing: border-box;padding: 10px 20px;border-bottom: 1px solid #515151;">
            <span style="width: 6%;">{{billItem.user_money}}</span>
            <span>{{billItem.atime}}</span>
            <span style="color: coral;">{{billItem.desc}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },
    data() {
      return {
        currentTab: 1,
        cateid: 0,

        page: 1,
        limit: "",
        bill: [],
        mescroll: null,

      }
    },
    computed: {

    },
    created() {

    },
    mounted() {
      this.mescrollInit()

    },
    methods: {

      onChangeCurrent(type) {
        this.currentTab = type

        this.mescrollInit()
      },
      onChange(e) {
        this.cateid = e + 1

        this.mescrollInit()
      },
      // getBill() {
      //   this.get('api/users/WithdrawLists', {
      //     page:this.page,
      //     limit:this.limit
      //   }).then((res) => {
      //     if (res.code == 0) {
      //       let length = res.data.lists.length
      //       this.bill = res.data.lists
      //     }
      //   })
      // },
      // mescroll组件初始化的回调,可获取到mescroll对象
      mescrollInit() {
        let _this = this;
        _this.mescroll = null
        _this.mescroll = new MeScroll('z-bill-mescroll', {
          up: {
            callback: _this.upCallback
          },
          down: {
            auto: false,
            htmlContent: ' ',
            callback: function(ms) {
              _this.mescroll.endErr(); // 使用endError把下拉的效果关闭（内容回到原位）， mescroll内部会自动恢复原来的页码,时间等变量
            }
          }
        })
      },
      // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
      upCallback(page, mescroll) {
        // console.log(page)
        let _this = this
        _this.getBill(page.num, function(rs) {

        })
      },
      getBill(pageIndex, callback) {
        let _this = this
        // 联网请求
        this.get('/api/users/amountList', {
          page: pageIndex, // 页码
          limit: 10, // 每页长度
          cateid: this.cateid, //1.佣金收入 2. 盈利分成分 3.感恩奖励 4.推荐奖励 5.通证明细
          typeid: this.currentTab //1.收入 2.支出
        }).then((rs) => {
          let arr = rs.data.lists
          // 如果是第一页需手动置空列表
          if (pageIndex === 1) {
            _this.bill = []
          }

          if (arr.length == 0) {
            _this.$store.commit('layer', '暂无数据')

          } else {
            // 把请求到的数据添加到列表
            _this.bill = _this.bill.concat(arr)
          }
          callback && callback(rs)
          // 数据渲染成功后,隐藏下拉刷新的状态
          _this.$nextTick(() => {
            _this.mescroll.endSuccess(arr.length)
          })

        }).catch((e) => {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          _this.mescroll.endErr()
        })
      },

    }
  }
</script>

<style scoped>
  .bill-tabbar {
    border: 1px solid #000000;
    width: 90%;
  }

  .common-tab {
    width: 50%;
    box-sizing: border-box;
    padding: 2px 0;
    text-align: center;
    color: #000000;
  }

  .active {
    background: #000;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/my/bill.vue